import { render, staticRenderFns } from "./CallRecordShare.vue?vue&type=template&id=5c5743f8&scoped=true&"
import script from "./CallRecordShare.vue?vue&type=script&lang=js&"
export * from "./CallRecordShare.vue?vue&type=script&lang=js&"
import style0 from "./CallRecordShare.vue?vue&type=style&index=0&id=5c5743f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5743f8",
  null
  
)

export default component.exports